module.exports = __webpack_public_path__ + "static/media/hour-glass2.489c930b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/hour-glass2.svg
// module id = 3045
// module chunks = 7